import { InterfaceLanguage, SalesBanners } from 'types/enums';
import request from 'utils/request';
import { v4 as uuidv4 } from 'uuid';
import { GetBannersResponse } from '../interfaces/Common';
import { ProfileType } from '../interfaces/IRegistration';

export default class BannerRepository {
  static async getBanners(
    profile: ProfileType = ProfileType.Employee,
    token: string | null,
    bannersTypes: SalesBanners[],
    language: InterfaceLanguage,
    uuid?: string | null,
  ): Promise<GetBannersResponse> {
    const params = {
      positions: JSON.stringify(bannersTypes.map((p) => p.toUpperCase()).join(',')).replaceAll(
        '"',
        '',
      ),
      profileType: profile,
      uuid: !!uuid ? uuid : uuidv4(),
    };

    if (!token) {
      delete params.uuid;
    }

    if (params.uuid === 'undefined') {
      delete params.uuid;
    }

    const res = await request({
      method: 'get',
      url: `/api/banner`,
      profile,
      ignoreToken: true,
      data: {
        language,
        ...params,
      },
    });
    if (res.err) {
      return null;
    }
    return res;
  }
}
